export default __webpack_public_path__ + "static/media/ads-video-popular-events.8f620371.mp4";